export default __webpack_public_path__ + "static/media/icon-job-location.6715621b.svg";